<template>
<div :class="componentClass">
  <b-container class="p-3">
    <div v-if="twilioStatus == 'initializing'">Connecting to phone server.</div>
    <b-row v-if="twilioStatus == 'offline'">
      <b-col class="md-9 my-auto">
        You're offline.
      </b-col>
      <b-col class="md-3 text-right">
        <b-button variant="success" @click="startSession()">Go Online</b-button>
      </b-col>
    </b-row>
    <b-row v-if="twilioStatus == 'ready'">
      <b-col class="md-9 my-auto">
        Connected and ready to make and accept calls.
      </b-col>
      <b-col class="md-3 text-right">
        <b-button variant="light" @click="endSession()">Go Offline</b-button>
      </b-col>
    </b-row>
    <b-row v-if="twilioStatus == 'busy'">
      <b-col class="md-9 my-auto">
        You're speaking to {{activeCall.name}}
      </b-col>
      <b-col class="md-3 text-right">
        <b-button variant="danger" @click="hangup()">Hangup</b-button>
      </b-col>
    </b-row>
  </b-container>
  <b-modal id="call-report-modal" title="Call Notes" ok-only ok-title="Save" :ok-disabled="!note" @ok="saveReport" :busy="sending">
    <b-form-group label="Member Status">
      <member-status-control v-if="activeCall" :member="activeCall"></member-status-control>
    </b-form-group>
    <b-form-group label="Call Notes">
      <b-form-textarea class="mt-3" v-model="note" placeholder="Type notes..." rows="5" :disabled="sending"></b-form-textarea>
    </b-form-group>
  </b-modal>
</div>
</template>
<script>
import $twilio from '@/services/twilio.js';
import $auth from '@/services/auth.js';
import { Device } from 'twilio-client';
import { UpdateClientCall } from '@/gql/members/Calls.gql';
import MemberStatusControl from '@/components/members/MemberStatusControl';

export default {
  components: {
    MemberStatusControl,
  },
  data() {
    return {
      twilioStatus: 'initializing',
      activeCall: null,
      note: null,
      sending: false
    }
  },
  methods: {
    handleTwilioStatusChange() {
      this.twilioStatus = Device.status();
    },
    hangup() {
      Device.disconnectAll();
    },
    showReportModal() {
      console.log(this.activeCall);
      this.$bvModal.show('call-report-modal');
    },
    async saveReport(evt) {
      evt.preventDefault(); // Prevent from closing automatically
      this.sending = true;
      await this.$apollo.mutate({
        mutation: UpdateClientCall,
        variables: {
          callId: this.activeCall.sid,
          note: this.note
        }
      });
      this.sending = false;
      this.$bvModal.hide('call-report-modal')
      this.activeCall = null;
    },
    startSession() {
      this.twilioStatus = 'initializing';
      $twilio.init();
      Device.on('ready', this.handleTwilioStatusChange);
      Device.on('offline', this.handleTwilioStatusChange);
      Device.on('connect', (connection) => {
        this.activeCall = this.activeCall || $twilio.getActiveCall();
        console.log(this.activeCall);
        this.activeCall.sid = connection.parameters.CallSid;
        this.handleTwilioStatusChange();
      });
      Device.on('disconnect', (connection) => {
        this.handleTwilioStatusChange();
        this.showReportModal();
      });
      Device.on('error', (error) => {
        console.error(error);
      });
      Device.on('incoming', async (connection) => {
        this.activeCall = connection.message;
        let answer = await this.$bvModal.msgBoxConfirm('Incoming call', {
          okTitle: 'Accept',
          cancelTitle: 'Decline'
        })
        if (answer) {
          connection.accept();
        } else {
          connection.decline();
        }
      })
    },
    endSession() {
      $twilio.endSession();
    }

  },
  computed: {
    componentClass() {
      return this.twilioStatus;
    }
  },
  created() {
    this.startSession();
  }
}
</script>
<style scoped>
.initializing {
  background-color: var(--light);
}

.ready {
  background-color: var(--success);
  color: white;
}

.busy {
  background-color: var(--primary);
  color: white;
}

.offline {
  background-color: var(--info);
  color: white;
}
</style>
